
// import coreUserselect from "./core-userselect.vue";
import coreForm from "./form/form.vue";
import coreFormCard from "./form/form-card.vue";
import coreFormItem from "./form/form-item.vue";
import coreTreeconfig from "./treeconfig/core-treeconfig.vue"
import Vue from 'vue';
// 注册到全局
// Vue.component("core-userselect", coreUserselect);
Vue.component("core-form", coreForm);  //表单
Vue.component("core-form-card", coreFormCard);
Vue.component("core-form-item", coreFormItem);  //表单item
Vue.component("core-treeconfig", coreTreeconfig);
